var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8501 5.57495C16.7251 3.84995 15.3168 2.5 13.6501 2.5H6.34178C4.67511 2.5 3.26678 3.84995 3.14178 5.57495L2.53347 13.9166C2.4668 14.8666 2.79178 15.8 3.42511 16.4833C4.03345 17.1416 4.85013 17.5 5.73346 17.5H14.2584C15.1334 17.5 15.9585 17.1416 16.5668 16.4833C17.2001 15.8 17.5251 14.8666 17.4585 13.9166L16.8501 5.57495ZM15.3501 15.3416C15.0585 15.6583 14.6751 15.825 14.2584 15.825H5.73346C5.32513 15.825 4.93345 15.65 4.65011 15.3416C4.32511 14.9916 4.1668 14.5166 4.20013 14.0333L4.80845 5.69163C4.87512 4.8333 5.55011 4.15833 6.34178 4.15833H13.6501C14.4501 4.15833 15.1251 4.8333 15.1835 5.69163L15.7918 14.0333C15.8251 14.5166 15.6668 15 15.3418 15.3416H15.3501Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 5C12.042 5 11.667 5.375 11.667 5.83333C11.667 6.75 10.917 7.5 10.0003 7.5C9.08366 7.5 8.33366 6.75 8.33366 5.83333C8.33366 5.375 7.95866 5 7.50033 5C7.04199 5 6.66699 5.375 6.66699 5.83333C6.66699 7.675 8.15866 9.16667 10.0003 9.16667C11.842 9.16667 13.3337 7.675 13.3337 5.83333C13.3337 5.375 12.9587 5 12.5003 5Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.7394bd8dbde7eef935d1b0e5b9c2c0da.svg";
export { ForwardRef as ReactComponent };